import { h } from 'preact'

export default function studyRewardNotificationXpView ({ xpChanged, xpEarned }) {
  return xpChanged && h('div', {
    class: 'reward-notification good'
  }, `${xpEarned} XP`)
}
